import type { Locale } from "date-fns"
import { format, formatDistanceToNow } from "date-fns"

import { IDateFormatter } from "../interfaces"

export default class DateFnsFormatter extends IDateFormatter {
  format(date: number | Date, formatString: string) {
    return format(date, formatString)
  }

  formatDistanceToNow(
    date: number | Date,
    options: { includeSeconds?: boolean; addSuffix?: boolean; locale?: Locale } | undefined,
  ) {
    return formatDistanceToNow(date, options)
  }

  formatCountdownTimer(seconds: number) {
    const days = Math.floor(seconds / 86400)
    const hours = Math.floor((seconds % 86400) / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    const pad = (num: number, size: number) => String(num).padStart(size, "0")

    const parts = []

    if (days > 0) {
      parts.push(`${days}d`)
      parts.push(`${pad(hours, 2)}h`)
    } else if (hours >= 1) {
      parts.push(`${hours}h`)
    }

    parts.push(`${pad(minutes, 2)}m`)
    parts.push(`${pad(secs, 2)}s`)

    return parts.join(":")
  }
}
